export default defineNuxtRouteMiddleware(to => {
  const forbiddenPattern = /(?:^|[\\[\]._])(?:__proto__|constructor|prototype)(?:$|[\\[\]._])/i
  const sanitizedQuery = { ...to.query }
  let hasUnsafeKey = false

  Object.keys(to.query).forEach(key => {
    if (forbiddenPattern.test(key)) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete sanitizedQuery[key]
      hasUnsafeKey = true
    }
  })

  if (!hasUnsafeKey) return

  return navigateTo(
    {
      path: to.path,
      query: sanitizedQuery,
      hash: to.hash
    },
    { replace: true }
  )
})
